module.exports = __webpack_public_path__ + "img/387047.c0d5dd70.svg";